import pic from "./assets/img.jpg";
import "./style/App.css";
import AboutMe from "./components/AboutMe";
import Projects from "./components/Projects";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="app-container">
      <header className="header"></header>

      <div className="main-content">
        <section className="hero-section">
          <div className="profile-container">
            <img src={pic} alt="Profile" className="profile-image" />
            <div className="title">Yaman Sanobar</div>
            <div className="subtitle">Full Stack Developer & Educator</div>
          </div>

          <div className="intro">
            I'm a full-stack developer and educator with a passion for building
            scalable, user-centered applications and empowering the next
            generation of developers. With expertise spanning the entire
            technology stack—from frontend frameworks to backend architectures
            and database systems—I specialize in creating robust, maintainable
            solutions that solve real-world problems.
            <br />
            <br />
            Currently, I teach full-stack development, bridging the gap between
            theory and practice by helping students build production-ready
            applications. My unique background combines industry experience,
            academic research, and teaching, equipping me with a comprehensive
            understanding of both how software is engineered and how it's
            experienced by users.
            <br />
            <br />I am also deeply engaged with the rapidly evolving field of
            artificial intelligence, actively exploring how AI is transforming
            software development and user experiences. I aim to stay at the
            forefront of this shift—integrating modern AI capabilities into my
            work and helping others understand and adapt to this ongoing
            technological revolution.
          </div>
        </section>

        <section className="content-section">
          <AboutMe />
        </section>

        <section className="content-section">
          <Projects />
        </section>
      </div>

      <Footer />
    </div>
  );
}

export default App;
